import React, {Fragment, useEffect} from 'react';
import {Helmet} from 'react-helmet-async';

import {StyledGrid} from 'presentation/components/Grid';
import {FooterMobile} from 'presentation/components/MainFooter/FooterMobile';
import {useHostName} from 'presentation/hooks/useHostName';
import {useIsComingFromInitialFlowStore} from 'presentation/pages/others/selection-flow/store/useIsComingFromInitialFlowStore';
import {useSelectedBeneficiaryStore} from 'presentation/pages/others/selection-flow/store/useSelectedBeneficiaryStore';
import {useSelectedPlanStore} from 'presentation/pages/others/selection-flow/store/useSelectedPlanStore';
import {useMediaQueries} from 'presentation/pages/private';
import {useLocation} from 'react-router-dom';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {useSetRecoilState} from 'recoil';
import {accountDataStateRefresher} from 'presentation/pages/states';
import {ContractNow} from '../components';
import {TermsOfUseAndPrivacyPolicy} from '../components/TermsOfUseAndPrivacyPolicy';
import {useResetPublicFlow} from '../hooks';
import {SectionContent} from '../styles';
import {AppStore, Header, NewRegister, SignInForm} from './components';
import {AlertB2B} from './components/AlertB2B';
import {useRegistrationUpdateStatusStore} from 'presentation/pages/private/store/useRegistrationUpdateStatusStore';
import {LoginEnum} from 'main/analytics/gaTagsEnum';
import {UserManualAlert} from 'presentation/components/UserManualAlert';
import {useAddressUpdateModalDisplayStore} from 'presentation/pages/private/home/store/useAddressUpdateModalDisplayStore';

export function SignIn() {
	const {dataHostNameState} = useHostName();
	const {productName} = dataHostNameState;
	const {isTablet} = useMediaQueries();
	const {state} = useLocation();

	const {handleResetPublicFlow} = useResetPublicFlow();
	const resetAccountData = useAccountDataStore(store => store.resetAccountData);
	const resetSelectedPlan = useSelectedPlanStore(currentState => currentState.resetSelectedPlan);
	const resetSelectedBeneficiary = useSelectedBeneficiaryStore(
		currentState => currentState.resetSelectedBeneficiary,
	);
	const resetIsComingFromInitialFlow = useIsComingFromInitialFlowStore(
		currentState => currentState.resetIsComingFromInitialFlow,
	);
	const resetRegistrationUpdateStore = useRegistrationUpdateStatusStore(
		state => state.resetRegistrationUpdateStore,
	);
	const resetAddressUpdateModalDisplayControl = useAddressUpdateModalDisplayStore(
		state => state.resetDisplayControl,
	);
	const setAccountDataStateRefresher = useSetRecoilState(accountDataStateRefresher);

	useEffect(() => {
		resetAccountData();
		setAccountDataStateRefresher(val => val + 1);
		resetSelectedPlan();
		resetRegistrationUpdateStore();
		resetAddressUpdateModalDisplayControl();
		resetIsComingFromInitialFlow();
		resetSelectedBeneficiary();
		handleResetPublicFlow();
	}, []);

	return (
		<Fragment>
			<Helmet>
				<title>{`${productName}`}</title>
			</Helmet>

			<StyledGrid.Root>
				<StyledGrid.Item sm={12} md={12} lg={12}>
					<Header />
					<SectionContent>
						{state?.b2bError ? <AlertB2B /> : null}
						<UserManualAlert dataTagId={LoginEnum.CLICK_ACESSAR_MANUAL} type="access" />
						<SignInForm />
						<NewRegister />
						<TermsOfUseAndPrivacyPolicy />
						{isTablet ? <AppStore /> : null}
						<ContractNow />
						<FooterMobile hideANS={!isTablet} hidePolicy />
					</SectionContent>
				</StyledGrid.Item>
			</StyledGrid.Root>
		</Fragment>
	);
}
